import {
  claimSocialWebsite,
  disableSocialAds,
  disableSocialCatalog,
  disconnectSocial,
  enableSocialAds,
  enableSocialCatalog,
  getSocialAnalyticsOverview,
  getSocialCatalog,
  ingestSocialCatalog,
  listSocialAdAccounts,
  listSocialConnections,
  startSocialAdsConnect,
  startSocialConnect,
  type EnableSocialAdsRequest,
  type SocialAdAccountList,
  type SocialAnalyticsOverview,
  type SocialAuthorizeUrl,
  type SocialCatalogStatus,
  type SocialConnection,
  type SocialConnectionList,
  type SocialConnectPurpose,
  type SocialProvider,
} from '@nucleus-commerce/api-client/admin';

/** Social channels: the network connections, the catalogue sync switch and the ads step. */
export const socialApi = {
  connections: (storeId: string): Promise<SocialConnectionList> =>
    listSocialConnections({ storeId }),
  /** Tiles, daily series and top products over inclusive store calendar days; 200 with `connected: false` when the network is not connected. */
  analyticsOverview: (
    storeId: string,
    range: { from: string; to: string },
  ): Promise<SocialAnalyticsOverview> => getSocialAnalyticsOverview({ storeId }, range),
  /** Answers the network's authorization URL; the browser is sent there. */
  connect: (
    storeId: string,
    provider: SocialProvider,
    purpose: SocialConnectPurpose,
  ): Promise<SocialAuthorizeUrl> =>
    purpose === 'ads'
      ? startSocialAdsConnect({ storeId, provider })
      : startSocialConnect({ storeId, provider }, { purpose }),
  disconnect: (storeId: string, provider: SocialProvider): Promise<void> =>
    disconnectSocial({ storeId, provider }),

  /** Read live from the network; `{ enabled: false }` while sync is off. */
  catalog: (storeId: string, provider: SocialProvider): Promise<SocialCatalogStatus> =>
    getSocialCatalog({ storeId, provider }),
  enableCatalog: (storeId: string, provider: SocialProvider): Promise<SocialCatalogStatus> =>
    enableSocialCatalog({ storeId, provider }),
  disableCatalog: (storeId: string, provider: SocialProvider): Promise<SocialCatalogStatus> =>
    disableSocialCatalog({ storeId, provider }),
  ingestCatalog: (storeId: string, provider: SocialProvider): Promise<SocialCatalogStatus> =>
    ingestSocialCatalog({ storeId, provider }),

  /** Claims the store's primary domain on the connected account; answers the connection with `website`. */
  claimWebsite: (storeId: string, provider: SocialProvider): Promise<SocialConnection> =>
    claimSocialWebsite({ storeId, provider }),

  adAccounts: (storeId: string, provider: SocialProvider): Promise<SocialAdAccountList> =>
    listSocialAdAccounts({ storeId, provider }),
  enableAds: (
    storeId: string,
    provider: SocialProvider,
    body: EnableSocialAdsRequest,
  ): Promise<SocialConnection> => enableSocialAds({ storeId, provider }, body),
  disableAds: (storeId: string, provider: SocialProvider): Promise<SocialConnection> =>
    disableSocialAds({ storeId, provider }),
};
